<div class="modal-body">
  <h4>Attenzione</h4>
  <label>per poter procedere all'inserimento dei tuoi annunci devi completare il profilo personale con i tuoi dati</label>
  <div class="text-right">
    <button class="btn btn-primary" (click)="changeUrl()">Ok</button>
  </div>
</div>
